import { Navigate, Route, Routes } from 'react-router-dom';
import AdminRoute from '../components/auth/AdminRoute';
import HelpdeskPage from '../pages/HelpdeskPage';
import AdminUsersPage from '../pages/AdminUsersPage';
import AdminAnnouncementsPage from '../pages/AdminAnnouncementsPage';
import CreateAnnouncementPage from '../pages/CreateAnnouncementPage';
import CreateUserPage from '../pages/CreateUserPage';
import CreateArticlePage from '../pages/CreateArticlePage';
import KnowledgeBasePage from '../pages/KnowledgeBasePage';
import LoginPage from '../pages/LoginPage';
import PublicArticlePage from '../pages/PublicArticlePage';
import PublicArticlesPage from '../pages/PublicArticlesPage';
import PublicAnnouncementPage from '../pages/PublicAnnouncementPage';

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<HelpdeskPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/articles" element={<PublicArticlesPage />} />
      <Route path="/articles/:identifier" element={<PublicArticlePage />} />
      <Route path="/announcements" element={<HelpdeskPage />} />
      <Route path="/announcements/:identifier" element={<PublicAnnouncementPage />} />
      <Route
        path="/knowledge-base"
        element={
          <AdminRoute>
            <KnowledgeBasePage />
          </AdminRoute>
        }
      />
      <Route
        path="/knowledge-base/create-article"
        element={
          <AdminRoute>
            <CreateArticlePage />
          </AdminRoute>
        }
      />
      <Route
        path="/knowledge-base/edit/:articleId"
        element={
          <AdminRoute>
            <CreateArticlePage />
          </AdminRoute>
        }
      />
      <Route
        path="/admin/announcements"
        element={
          <AdminRoute>
            <AdminAnnouncementsPage />
          </AdminRoute>
        }
      />
      <Route
        path="/admin/announcements/create"
        element={
          <AdminRoute>
            <CreateAnnouncementPage />
          </AdminRoute>
        }
      />
      <Route
        path="/admin/announcements/edit/:announcementId"
        element={
          <AdminRoute>
            <CreateAnnouncementPage />
          </AdminRoute>
        }
      />
      <Route
        path="/admin/users/create"
        element={
          <AdminRoute>
            <CreateUserPage />
          </AdminRoute>
        }
      />
      <Route
        path="/admin/users"
        element={
          <AdminRoute>
            <AdminUsersPage />
          </AdminRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default AppRoutes;
